// removed by extract-text-webpack-plugin
module.exports = {"sectionWrapper":"src-components----default-module---sectionWrapper---ulNM8","fullPageWrapper":"src-components----default-module---fullPageWrapper---LwUix","invertText":"src-components----default-module---invertText---2rGQL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/default.module.css
// module id = 25
// module chunks = 168707334958949